import { MiamiFlow } from "@/pages/MiamiPage";
import {
  INDUSTRIES_FR,
  PEOPLE_BUCKETS_FR,
  CAPACITY_QUESTIONS_FR,
  CAPACITY_EXAMPLE_FR,
  getIndustryFr,
  MIAMI_FR,
} from "@/data/miamiConfigFr";

export default function FrMiamiPage() {
  return (
    <MiamiFlow
      industries={INDUSTRIES_FR}
      buckets={PEOPLE_BUCKETS_FR}
      questions={CAPACITY_QUESTIONS_FR}
      example={CAPACITY_EXAMPLE_FR}
      getIndustryFn={getIndustryFr}
      copy={MIAMI_FR}
      source="/fr/miami"
    />
  );
}
